<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="客户" prop="custCode">
            <dict-select
              v-model="formData.custCode"
              url="/master/customer/info/select"
              placeholder="请选择客户"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="门点编号">
            <el-input
              v-model="formData.pointNo"
              placeholder="系统自动生成"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="门点名称" prop="pointName">
            <el-input
              v-model="formData.pointName"
              placeholder="请输入门点名称"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="收发货方指定" prop="pointType">
            <el-select
              v-model="formData.pointType"
              placeholder="请选择"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option label="收货" value="R"></el-option>
              <el-option label="发货" value="D"></el-option>
              <el-option label="收/发货" value="X"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input
              v-model="formData.contactName"
              placeholder="请输入联系人姓名"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="联系人手机号" prop="contactMobile">
            <el-input
              maxlength="11"
              v-model="formData.contactMobile"
              placeholder="请输入联系人手机号"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="固定电话">
            <el-input
              v-model="formData.contactPhone"
              placeholder="请输入固定电话"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="联系人E-mail" prop="contactEmail">
            <el-input
              v-model="formData.contactEmail"
              placeholder="请输入联系人E-mail"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="省/市/县">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
              size="small"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="详细地址" prop="detailAddress" size="small">
            <el-input
              size="small"
              placeholder="请输入详细地址"
              v-model="formData.detailAddress"
            >
              <el-button
                slot="append"
                size="small"
                icon="el-icon-map-location"
                @click="openCoordPickerDialog()"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="有效状态" prop="pointStatus">
            <el-radio-group v-model="formData.pointStatus">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <el-form-item label="默认电子围栏半径（米）">
            <el-input-number
              v-model.number="formData.pointFence"
              placeholder="请输入电子围栏半径"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
              size="small"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="可用日期">
            <el-checkbox-group v-model="formData.weekDaySet">
              <el-checkbox :label="1">周一</el-checkbox>
              <el-checkbox :label="2">周二</el-checkbox>
              <el-checkbox :label="3">周三</el-checkbox>
              <el-checkbox :label="4">周四</el-checkbox>
              <el-checkbox :label="5">周五</el-checkbox>
              <el-checkbox :label="6">周六</el-checkbox>
              <el-checkbox :label="7">周日</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="三方门点编号" prop="tdpPointNo">
            <el-input
              v-model="formData.tdpPointNo"
              placeholder="请输入三方门点编号"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="特殊要求">
            <el-input
              v-model="formData.pointDesc"
              placeholder="请输入特殊要求"
              type="textarea"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <coord-picker-dialog
      v-if="coordPickerDialogVisible"
      :visible.sync="coordPickerDialogVisible"
      :city="formData.cityName"
      :address.sync="formData.detailAddress"
      :longitude.sync="formData.pointLongitude"
      :latitude.sync="formData.pointLatitude"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
export default {
  props: {
    disabled: Boolean,
    params: { type: Object, default: () => {} }
  },
  components: {},
  computed: {
    days() {
      return Array.from({ length: 31 }).map((v, i) => i + 1)
    }
  },
  data() {
    return {
      regionShow: false,
      coordPickerDialogVisible: false,
      openCoordPickerDialogOptions: {
        visible: false
      },
      backDialogVisible: false,
      formData: {
        pointStatus: 'Y',
        useTransWeight: 'Y',
        weekDaySet: [],
        pointType: 'X',
        detailAddress: ''
      },
      rules: {
        custCode: [
          {
            required: true,
            message: '请选择客户',
            trigger: 'change'
          }
        ],
        pointType: [
          {
            required: true,
            message: '请选择收发货方',
            trigger: 'change'
          }
        ],
        pointName: [
          {
            required: true,
            message: '请输入门点名称',
            trigger: 'blur'
          }
        ],
        detailAddress: [
          {
            required: true,
            message: '请输入详细地址',
            trigger: 'blur'
          }
        ],
        contactMobile: [
          {
            required: false,
            message: '请输入正确的手机号',
            trigger: 'blur',
            pattern: /^\d{11}$/
          }
        ],

        contactEmail: [
          {
            required: false,
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    openCoordPickerDialog() {
      this.coordPickerDialogVisible = true
    },
    getData() {
      if (!this.params.pointCode) return (this.regionShow = true)
      this.$api
        .contractCustomerGateDetailApi({
          pointCode: this.params.pointCode
        })
        .then((res) => {
          this.formData = res.body
          this.formData.weekDaySet = JSON.parse(this.formData.weekDaySet)
          this.regionShow = true
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return
      if (!this.formData.pointLongitude) {
        this.$message({
          message: '请选取门点经纬度',
          type: 'warning'
        })
        return
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$api
        .contractCustomerGateSaveApi(this.formData)
        .then(() => {
          loadingInstance.close()
          this.saveOkQuestion()
          //刷新列表
          this.$eventBus.$emit('customerGateTableReload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    disable() {
      if (this.formData.useTransWeight == 'Y') {
        return false
      } else {
        return true
      }
    },
    saveOkQuestion() {
      this.$alert('客户门点数据保存成功', '提示信息', {
        confirmButtonText: '确定',
        callback: () => {
          this.closeCurPage()
        }
      })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false
      })
    }
  }
}
</script>
